import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, FormActions } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, enableCustomTemplates, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='name' component={Input} type='text' label={t('MessageTemplate_Name')} />
						</Col>
						<Col sm={6}>
							<Field name='enabled' component={Input} componentClass='select' label={t('MessageTemplate_Enabled')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
					</Row>
					{enableCustomTemplates && <Row>
						<Col sm={6}>
							<Field name='isSystem' component={Input} componentClass='select' label={t('MessageTemplate_Category')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('MessageTemplate_System')}</option>
								<option value={false}>{t('MessageTemplate_Custom')}</option>
							</Field>
						</Col>
					</Row>}
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'messageTemplatesFilter' })(withTranslation()(Filter));